export default __webpack_public_path__ + "static/media/welcome-cny-bonus.b6a885fd.webp";